/** Pure logic for the Mail Order Batch list (filters live in the page URL). */

export type BatchStatusFilter = 'all' | 'open' | 'closed' | 'deposited' | 'archived'
export interface BatchFilters { status: BatchStatusFilter; from: string; to: string }

const STATUSES: BatchStatusFilter[] = ['all', 'open', 'closed', 'deposited', 'archived']
const isDay = (v: string | null): v is string => !!v && /^\d{4}-\d{2}-\d{2}$/.test(v)

/** Filters from the page's search params; anything unrecognised falls back to "everything". */
export function filtersFromParams(p: URLSearchParams): BatchFilters {
  const s = p.get('status') as BatchStatusFilter | null
  return {
    status: s && STATUSES.includes(s) ? s : 'all',
    from: isDay(p.get('from')) ? p.get('from')! : '',
    to: isDay(p.get('to')) ? p.get('to')! : '',
  }
}

/** The same filters back as page search params, leaving defaults out. */
export function filtersToParams(f: BatchFilters): Record<string, string> {
  const out: Record<string, string> = {}
  if (f.status !== 'all') out.status = f.status
  if (f.from) out.from = f.from
  if (f.to) out.to = f.to
  return out
}

/** Query string for GET /api/desk/batches. */
export function batchListQuery(f: BatchFilters): string {
  const q = new URLSearchParams()
  if (f.status !== 'all') q.set('status', f.status)
  if (f.from) q.set('date_from', f.from)
  if (f.to) q.set('date_to', f.to)
  const s = q.toString()
  return s ? `?${s}` : ''
}

export const STATUS_WORD: Record<'open' | 'closed' | 'deposited', string> = { open: 'Open', closed: 'Closed', deposited: 'Deposited' }

/** "Oct 5, 2026, 9:14 AM" in the reader's own time zone. */
export function openedAtText(iso: string): string {
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? iso
    : d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
}
